export default __webpack_public_path__ + "static/media/loginBackground.abb108d9.png";